import { useAuthContext } from '@color/lib';
import { useState } from 'react';

import { usePatientMessagingContext } from 'ui/App/Providers/PatientMessagingProvider';

import { useSmoochLoginQuery, useZendeskUserJWT } from './apis/api';

export const usePatientMessagingLogin = () => {
  const [isLoading, setIsLoading] = useState(true);
  const { data: jwtResponse, error: jwtError } = useZendeskUserJWT();
  const { currentUser } = useAuthContext();
  const {
    patientMessagingInitResponse: {
      isLoading: isInitLoading,
      isError: isInitError,
      error: initError,
    },
  } = usePatientMessagingContext();

  const { isError: isLoginError, error: loginError } = useSmoochLoginQuery(
    isInitLoading,
    currentUser,
    jwtResponse?.token,
    setIsLoading
  );

  return {
    patientIsNotOnboarded: jwtError && jwtError.status === 404,
    isSmoochLoginError: isInitError || isLoginError,
    loginError,
    initError,
    isLoading: isLoading || !currentUser || isInitError || isLoginError,
  };
};
